
import {humanizeUnitAmount, subscriptionService} from 'src/modules/user/subscription/SubscriptionService';
import {userService} from 'src/modules/user/UserService';
import {isInIOSApp} from 'src/utils/MobileUtils';
import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import {analyticsController} from 'src/modules/user/analytics/AnalyticsController';
import {catchupOnboarding} from 'src/modules/onboarding/slides/CatchupOnboarding';
import {currentPromotion} from './PromotionController';
import {getAssetItem} from 'src/utils/helpers';
import {languageManager} from 'src/boot/i18n';

@Component({
  methods: {
    humanizeUnitAmount: subscriptionService.humanizeUnitAmount,
    getAssetItem,
  },
})
export default class PromotionPopup extends Vue {
  private displayPopup = false;
  private isLoading = false;

  get isMiniMobile() {
    return this.$q.screen.height < 750;
  }
  get user() {
    return userService.user;
  }
  get hasFinishedOnboarding() {
    return this.user?.configurations.onboardingConfig.hasFinishedFirstOnboarding;
  }
  get prices() {
    if (subscriptionService.state.product) {
      return subscriptionService.state.product.prices.filter((price) => {
        if (this.currentPromotion?.wichItems.includes('all')) {
          return true;
        }

        if (this.currentPromotion?.wichItems.includes('annual') && price.recurring?.interval === 'year') {
          return true;
        }

        if (this.currentPromotion?.wichItems.includes('monthly') && price.recurring?.interval === 'month') {
          return true;
        }

        if (this.currentPromotion?.wichItems.includes('lifetime') && !price.recurring) {
          return true;
        }

        return false;
      });
    }

    return [];
  }
  get perMonthReductedPrice() {
    if (this.currentPromotion && this.prices.length) {
      const price = this.prices.find((price) => price.recurring?.interval === 'year');
      return subscriptionService.amountToHumanizeMonthlyCost(price, this.currentPromotion);
    }

    return '9.90';
  }
  get isCatchupSlideDisplayed() {
    return catchupOnboarding.state.isDisplayed;
  }
  get isCatchupSlideInitialised() {
    return catchupOnboarding.state.isInitialised;
  }
  get currentPromotion() {
    return currentPromotion;
  }
  get isCurrentPromotionInProgress() {
    return (
      !!this.currentPromotion && this.currentPromotion.isInProgress && this.currentPromotion.isPopupAndChipDisplayed
    );
  }
  get endDateString() {
    if (!this.currentPromotion) {
      return '';
    }
    return this.currentPromotion.endDateString[languageManager.currentLocaleLang] || '';
  }

  mounted() {
    this.openPopup();
  }

  goToSubscribePage() {
    this.isLoading = true;
    analyticsController.logAnalyticsEvent({
      title: 'clicked on subscribe button in promotion popup (black friday)',
      category: 'Marketing promotion',
    });
    this.$router.push('/subscribe?annual=true');
    this.displayPopup = false;
  }

  closePopup() {
    analyticsController.logAnalyticsEvent({title: 'closed promotion popup', category: 'Marketing promotion'});
  }

  @Watch('hasFinishedOnboarding')
  @Watch('isCatchupSlideDisplayed')
  @Watch('isCatchupSlideInitialised')
  openPopup() {
    if (
      this.displayPopup ||
      this.$route.path.includes('/player') ||
      this.$route.path.includes('learn') ||
      !this.currentPromotion
    ) {
      return;
    }
    const isPremium = this.user.premium && this.user.status !== 'TRIAL';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const visits: number[] = (
      JSON.parse(localStorage[this.currentPromotion.localStoragePromotionName] || '[]') as string[]
    ).map((el) => parseInt(el));

    if (
      !visits.includes(today.getTime()) &&
      visits.length <= 3 &&
      !isPremium &&
      this.hasFinishedOnboarding &&
      !this.isCatchupSlideDisplayed &&
      this.isCatchupSlideInitialised &&
      this.isCurrentPromotionInProgress
    ) {
      this.displayPopup = true;
      visits.push(today.getTime());
      localStorage[this.currentPromotion.localStoragePromotionName] = JSON.stringify(visits);
      analyticsController.logAnalyticsEvent({
        title: 'promotion popup displayed',
        category: 'Marketing promotion',
      });
    }
  }
}
